import * as actionTypes from './actionTypes';

export const addToActiveTrail = (key, replaceCurrent = false) => ({
  type: actionTypes.ADD_TO_ACTIVE_TRAIL,
  key,
  replaceCurrent,
});

export const setActiveTrail = activeTrail => ({
  type: actionTypes.SET_ACTIVE_TRAIL,
  activeTrail,
});

export const goBack = (amount = 1) => ({
  type: actionTypes.GO_BACK,
  amount,
});

export const toggleSubmenu = () => ({
  type: actionTypes.TOGGLE_SUBMENU,
});

export const toggleMobileMenu = () => ({
  type: actionTypes.TOGGLE_MOBILE_MENU,
});

export const setIsOpen = isOpen => ({
  type: actionTypes.SET_IS_OPEN,
  isOpen,
});
